import { FC, ReactElement } from 'react';
import cc from 'classcat';
import { EIconSize } from 'utils/constants/app/ui';
import { ResultsSport } from 'interfaces/results';
import { SportsMenuSkeleton } from './Skeleton';
import { GlobalIcon } from 'components/GlobalIcon';
import './index.less';

type Props = {
  sports: Omit<ResultsSport, 'Regions'>[] | undefined;
  onSelect: Function;
  selectedSport: number | undefined;
};

export const SportsMenu: FC<Props> = ({
  sports,
  onSelect,
  selectedSport
}): ReactElement => {
  return (
    <div className="sportsMenu">
      <div className="sportsMenu__content">
        {!sports ? (
          <SportsMenuSkeleton />
        ) : (
          sports?.map(sport => (
            <div
              key={sport.Id}
              className={cc([
                'sportsMenu__item',
                { 'sportsMenu__item--active': selectedSport === sport.Id }
              ])}
              onClick={() => {
                onSelect(sport.Id);
              }}
            >
              <div className="sportsMenu__itemIconWrapper">
                <GlobalIcon
                  lib="sports"
                  size={EIconSize._24}
                  name={sport.Alias.toLowerCase()}
                  className="text-color"
                />
              </div>
              <div className="sportsMenu__itemLabel">{sport.Name}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
